import type { RouteObject } from "react-router-dom";
import DataAdminFirmLayout from "../pages/ManageFirm/DataAdminFirmLayout";
import Professionals from "../pages/ManageFirm/Professionals/Professionals";
import AddProfessional, {
  addProfessionalEditLoader,
} from "../components/Organismos/Person/AddProfessional";
import ProfessionalUserLogs from "../pages/ManageFirm/Professionals/ProfessionalUserLogs";

export const DataAdminRoutes: RouteObject[] = [
  {
    path: "/manage-firm",
    element: <DataAdminFirmLayout />,
    children: [
      {
        path: "professionals",
        element: <Professionals dataAdminReadOnly />,
      },
      {
        path: "professionals/create",
        element: <AddProfessional mode="add" />,
      },
      {
        path: "professionals/edit/:generatedId",
        element: <AddProfessional mode="edit" />,
        loader: addProfessionalEditLoader,
      },
      { path: "professionals/logs", element: <ProfessionalUserLogs /> },
      { path: "professionals/logs/:userId", element: <ProfessionalUserLogs /> },
    ],
  },
];
